import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import classnames from 'classnames';
import {
  DragSource,
  DropTarget,
} from 'react-dnd';
import { getEmptyImage } from 'react-dnd-html5-backend';
import { Input } from 'reactstrap';

import DateTime from '../DateTime';
import FileActions from '../File/Actions';
import FileDetails from '../File/Details';
import FileTitle from '../File/Title';
import TrashRemainingDays from '../TrashRemainingDays';

import {
  filesTarget,
  filesSource,
} from '../../helpers/DNDFiles';
import ItemTypes from '../../helpers/DNDItemTypes';
import { getFilePageUrl } from '../../helpers/Files';

class FilesListItem extends PureComponent {
  componentDidMount() {
    const { connectDragPreview } = this.props;

    if (connectDragPreview) {
      connectDragPreview(getEmptyImage(), {
        captureDraggingState: true,
      });
    }
  }

  render() {
    const {
      file,
      collection,
      shareUuid,
      connectDragSource,
      connectDropTarget,
      isDragging,
      isMoved,
      isSelected,
      onFileSelect,
    } = this.props;

    const fileTo = getFilePageUrl({ fileUuid: file.uuid, shareUuid });

    return connectDragSource(connectDropTarget((
      <tr
        id={file.uuid}
        className={classnames('list-item', { dragging: isDragging })}
      >
        <td className="selector">
          <Input
            type="checkbox"
            className="input-check check-s form-check-input"
            id={`file-${file.uuid}`}
            checked={isSelected}
            onChange={() => onFileSelect(file.uuid, isSelected)}
          />
        </td>
        <td className="file-image">
          <div>
            {isMoved && (
              <span className="list-item-moved-icon">
                <i className="fas fa-sync fa-spin" />
              </span>
            )}
            {(file.type === 'link' && !file.html_code) ? (
              <a href={file.path} className="list-item-img-wrapper" title={file.display_name} target="_blank" rel="noopener noreferrer">
                <img
                  id={`file-img-${file.uuid}`}
                  className="list-item-img"
                  width="100%"
                  src={file.urls.thumbnail}
                  srcSet={`${file.urls.thumbnail} 1x, ${file.urls.thumbnailx2} 2x`}
                  alt={file.display_name}
                />
              </a>
            ) : (
              <Link to={fileTo} className="list-item-img-wrapper">
                <img
                  id={`file-img-${file.uuid}`}
                  className="list-item-img"
                  width="100%"
                  src={file.urls.thumbnail}
                  srcSet={`${file.urls.thumbnail} 1x, ${file.urls.thumbnailx2} 2x`}
                  alt={file.display_name}
                />
              </Link>
            )}
          </div>
        </td>
        <td className="file-name">
          <FileTitle
            className="list-item-title"
            file={file}
            fileTo={fileTo}
          />
          <div className="file-details-wrapper">
            <FileDetails
              className="list-item-details"
              file={file}
              showAccess={true}
            />
            <TrashRemainingDays
              file={file}
            />
          </div>
        </td>
        <td className="file-owner">
          {file.user?.name}
        </td>
        <td className="file-created">
          <DateTime
            id={`file-date-created-${file.uuid}`}
            className="file-date"
            dateTime={file.original_datetime}
          />
        </td>
        <td className="file-upload">
          <DateTime
            id={`file-date-${file.uuid}`}
            className="file-date"
            dateTime={file.last_upload_at || file.created_at}
          />
        </td>
        <td className="action-more">
          <FileActions
            file={file}
            collection={collection}
            shareUuid={shareUuid}
            filesView="list"
          />
        </td>
      </tr>
    )));
  }
}

const mapStateToProps = state => ({
  collection: state.Collections.collection,
});

FilesListItem.propTypes = {
  file: PropTypes.object.isRequired,
  collection: PropTypes.object,
  shareUuid: PropTypes.string,
  connectDragSource: PropTypes.func.isRequired,
  connectDropTarget: PropTypes.func.isRequired,
  connectDragPreview: PropTypes.func.isRequired,
  isDragging: PropTypes.bool.isRequired,
  isMoved: PropTypes.bool.isRequired,
  isSelected: PropTypes.bool.isRequired,
  onFileSelect: PropTypes.func.isRequired,
};

FilesListItem.defaultProps = {
  collection: null,
  shareUuid: null,
};

export default
withRouter(connect(mapStateToProps, null)(
  DragSource(ItemTypes.FILE, filesSource, (DNDconnect, monitor) => ({
    connectDragSource: DNDconnect.dragSource(),
    connectDragPreview: DNDconnect.dragPreview(),
    isDragging: monitor.isDragging(),
  }))(DropTarget([ItemTypes.FILE, ItemTypes.COLLECTION], filesTarget, DNDconnect => ({
    connectDropTarget: DNDconnect.dropTarget(),
  }))(FilesListItem)),
));
